import * as React from 'react';
export const TasksGlyph = (props) => (React.createElement("svg", { viewBox: "0 0 64 64", fill: "none", ...props },
    React.createElement("path", { d: "M21.2598 45.8999L38.4463 18.8999H52.0911L34.8619 45.8999H21.2598Z", fill: "var(--color__glyph__primary)" }),
    React.createElement("path", { d: "M34.8615 45.8998L25.5567 31.3308H11.9092L21.2594 45.8998H34.8615Z", fill: "var(--color__glyph__accent)" })));
